import React from "react";
import { Row, Col } from "react-bootstrap";

function Experience() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        Work <strong className="purple">Experience</strong>
      </h1>
      <Col md={8}>
        <div className="resume-item">
          <div className="resume-title">
            SDE1 · <span className="purple">Sopra Banking Software (SBS)</span>
          </div>
          <p style={{ opacity: 0.75, marginBottom: "10px" }}>
            Noida, India &middot; Aug 2023 &ndash; Present
          </p>
          <ul>
            <li>
              End-to-end ownership of the <b className="purple">Metadata</b>{" "}
              product, improving responsiveness by 20% and resolving 10+
              pre-existing bugs.
            </li>
            <li>
              Spearheaded vulnerability remediation across{" "}
              <b className="purple">50+ critical CVE</b> dependencies.
            </li>
            <li>
              Contributed to a year-long{" "}
              <b className="purple">Javax to Jakarta EE</b> migration, using
              GenAI tooling to cut redundant scripting/debugging work by 40%.
            </li>
            <li>
              Orchestrated a move to a fully automated{" "}
              <b className="purple">Docker + GitLab CI/CD</b> pipeline,
              tripling deployment frequency and cutting failures by 20%.
            </li>
            <li>
              Migrated 700,000+ JSP pages across a Javax&rarr;Jakarta and
              JBoss 7&rarr;8 upgrade; received the{" "}
              <b className="purple">Solitaire Award</b> for latency
              improvements on Verification of Payee.
            </li>
          </ul>
        </div>
      </Col>
    </Row>
  );
}

export default Experience;
